{
  "accept": "Accept",
  "action": "Action",
  "allCountries": "सभी Countries",
  "allPayments": "सभी Payments",
  "allTypes": "All Types",
  "amount": "अमाउंट",
  "asset": "Asset",
  "buy": "Buy",
  "buyer": "खरीदार",
  "cancel": "Cancel",
  "cancelFailed": "Cancel failed",
  "cancelled": "Cancelled",
  "completed": "Completed",
  "country": "Country",
  "createP2pAd": "P2P Ad बनाएं",
  "dispute": "विवाद",
  "disputeReason": "विवाद का कारण",
  "escrow": "Escrow",
  "escrowActive": "Escrow Active",
  "escrowProtection": "एस्क्रो सुरक्षा",
  "escrowReady": "Escrow Ready",
  "fillAllFields": "सभी fields भरें",
  "global": "Global",
  "globalP2pTrading": "ग्लोबल P2P ट्रेडिंग",
  "inEscrow": "Escrow में",
  "inTrade": "Trade में",
  "liveGlobalAds": "Live Global Ads",
  "loading": "लोड हो रहा है...",
  "markPaid": "Mark Paid",
  "noP2pAdsFound": "कोई P2P ad नहीं मिला।",
  "offline": "Offline",
  "online": "Online",
  "open": "Open",
  "openDispute": "विवाद खोलें",
  "orderCancelledRefunded": "Order cancel हो गया और asset refund हो गया",
  "orderDetails": "ऑर्डर विवरण",
  "orderId": "ऑर्डर आईडी",
  "p2pOrderCreated": "P2P order बन गया",
  "p2pSecurity": "P2P Security",
  "p2pSecurity1": "✅ User-to-user trading",
  "p2pSecurity2": "✅ Live database orders",
  "p2pSecurity3": "✅ Escrow status tracking",
  "p2pSecurity4": "✅ Payment proof upload",
  "p2pSecurity5": "✅ Admin can review all",
  "p2pSecurity6": "✅ Safe P2P status flow",
  "p2pSubtitle": "Secure escrow protection के साथ दुनिया भर में crypto खरीदें और बेचें।",
  "p2pTitle": "वैश्विक P2P ट्रेडिंग",
  "payment": "Payment",
  "paymentMethod": "भुगतान विधि",
  "paymentProof": "भुगतान प्रमाण",
  "paymentSent": "Payment Sent",
  "paymentSubmitted": "Payment submit हो गई",
  "pleaseLoginFirst": "कृपया पहले लॉगिन करें।",
  "price": "कीमत",
  "processing": "प्रोसेसिंग...",
  "release": "Release",
  "releaseFailed": "Release failed",
  "selectPaymentMethod": "Payment Method चुनें",
  "sell": "Sell",
  "seller": "विक्रेता",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "status": "स्टेटस",
  "totalOrders": "Total Orders",
  "tradeCompletedSuccessfully": "Trade successfully complete हो गई",
  "tradeFailed": "Trade failed",
  "tradeStartedSuccessfully": "Trade successfully start हो गई",
  "trader": "ट्रेडर",
  "unknownTrader": "व्यापारी",
  "uploadPaymentProof": "कृपया payment proof image upload करें",
  "uploadProof": "प्रमाण अपलोड करें",
  "verifiedMerchant": "Verified Merchant",
  "waitingEscrow": "Waiting Escrow",
  "walletAddress": "वॉलेट एड्रेस"
}